import { useOrganizationBranding } from '../../../../components/dashboard/use-organization-branding';
import { isPresentString } from './utils';

export function useClientPortalFirmBranding() {
  const { branding, loading } = useOrganizationBranding();

  const firmName = isPresentString(branding?.displayName) ? branding.displayName : null;

  return {
    firmName,
    firmLogoUrl: isPresentString(branding?.logoUrl) ? branding.logoUrl : null,
    // Managed-account labels prefer the org's short brand name; unbranded orgs read "Savvy".
    brandName: isPresentString(branding?.shortDisplayName) ? branding.shortDisplayName : (firmName ?? 'Savvy'),
    loading,
  };
}
